function DazProductSlab(productData, templateFunc, elemSelector, slabOptions) {
    this.productData = productData;
    this.templateFunc = templateFunc;
    this.elemSelector = elemSelector;
    this.slabOptions = slabOptions || DazProductSlab.cloneOptions('default');
    this.needPrice = false;
    this.needFilter = false;
    this.needSlab = true;
    this.retryCount = 10;
    this.currency = '';

    // Wait for filters and pricing to load
    if (typeof this.productData.canOrder == 'undefined') {
        this.needFilter = true;
        daz.filter.onLoad(this, this.loadFilter);
    }

    if (typeof this.productData.price == 'undefined') {
        this.needPrice = true;
        daz.api.getPrice(this.productData.id, this, this.loadPrice);
        daz.filter.onLoad(this, () => {
            daz.api.getPrice(this.productData.id, this, this.loadPrice);
        });
    }
}

DazProductSlab.requestCount = 0;

// This is my hack to stop effing with the cache
DazProductSlab.slabApiCacheVersion = 5;

// Catalog slab defaults
DazProductSlab.presetBase = {
    layout: 'card',
    showNewFlag: true,
    showSaleFlag: true,
    showOutletFlag: true,
    showWishlist: true,
    showSalePrice: true,
    showBasePrice: true,
    showAmountSaved: true,
    showCartButtons: true,
    showOwnedBanner: true,
    showInCartBanner: true,
    showCategoryIcons: true,
    showDazPlus: true,
    showDazOriginal: true,
    showFileFormats: true,
    showDownload: false,
    showRemove: false,
    showMinicartData: false,
};

DazProductSlab.presetOverrides = {
    carousel: {
        showCategoryIcons: false,
        showDazPlus: false,
        showDazOriginal: false,
        showAmountSaved: false,
    },
    minimal: {
        showNewFlag: false,
        showSaleFlag: false,
        showOutletFlag: false,
        showWishlist: false,
        showSalePrice: false,
        showBasePrice: false,
        showAmountSaved: false,
        showCartButtons: false,
        showOwnedBanner: true,
        showCategoryIcons: false,
        showDazPlus: false,
        showDazOriginal: false,
        showFileFormats: false,
    },
    minicart: {
        layout: 'horizontal',
        showNewFlag: false,
        showSaleFlag: false,
        showOutletFlag: false,
        showWishlist: false,
        showAmountSaved: false,
        showCartButtons: false,
        showCategoryIcons: false,
        showDazPlus: false,
        showDazOriginal: false,
        showFileFormats: false,
        showRemove: true,
        showMinicartData: true,
    },
    library: {
        showNewFlag: false,
        showSaleFlag: false,
        showOutletFlag: false,
        showWishlist: false,
        showSalePrice: false,
        showBasePrice: false,
        showAmountSaved: false,
        showCartButtons: false,
        showCategoryIcons: false,
        showOwnedBanner: false,
        showInCartBanner: false,
        showDazPlus: false,
        showDazOriginal: false,
        showFileFormats: false,
        showDownload: true,
    },
};

DazProductSlab.presets = {
    default: Object.assign({preset: 'default'}, DazProductSlab.presetBase),
};
for (const presetKey in DazProductSlab.presetOverrides) {
    if (!DazProductSlab.presetOverrides.hasOwnProperty(presetKey)) {
        continue;
    }
    DazProductSlab.presets[presetKey] = Object.assign(
        {preset: presetKey},
        DazProductSlab.presetBase,
        DazProductSlab.presetOverrides[presetKey]
    );
}

DazProductSlab.legacyTemplatePresets = {
    slab: 'default',
    minimalSlab: 'minimal',
    horizontalSlab: 'minicart',
};

DazProductSlab.legacyHolderPresets = {
    slabholder: 'default',
    minimalSlabholder: 'minimal',
    horizontalSlabHolder: 'minicart',
};

// data-slab-show-* attribute → options key
DazProductSlab.optionAttrMap = [
    ['data-slab-show-new-flag', 'showNewFlag'],
    ['data-slab-show-sale-flag', 'showSaleFlag'],
    ['data-slab-show-outlet-flag', 'showOutletFlag'],
    ['data-slab-show-wishlist', 'showWishlist'],
    ['data-slab-show-sale-price', 'showSalePrice'],
    ['data-slab-show-base-price', 'showBasePrice'],
    ['data-slab-show-amount-saved', 'showAmountSaved'],
    ['data-slab-show-cart-buttons', 'showCartButtons'],
    ['data-slab-show-owned-banner', 'showOwnedBanner'],
    ['data-slab-show-in-cart-banner', 'showInCartBanner'],
    ['data-slab-show-category-icons', 'showCategoryIcons'],
    ['data-slab-show-daz-plus', 'showDazPlus'],
    ['data-slab-show-daz-original', 'showDazOriginal'],
    ['data-slab-show-download', 'showDownload'],
    ['data-slab-show-remove', 'showRemove'],
    ['data-slab-show-minicart-data', 'showMinicartData'],
    ['data-slab-show-file-formats', 'showFileFormats'],
];

DazProductSlab.cloneOptions = function (presetKey) {
    const key = presetKey || 'default';
    const preset = DazProductSlab.presets[key] || DazProductSlab.presets.default;
    return Object.assign({}, preset);
};

DazProductSlab.readBoolAttr = function ($elem, attr) {
    const raw = $elem.attr(attr);
    if (raw === undefined || raw === null || raw === '') {
        return undefined;
    }
    return raw === '1' || raw === 'true';
};

DazProductSlab.resolvePresetKey = function ($container) {
    let presetKey = ($container.attr('data-slab-preset') || '').toLowerCase();
    if (presetKey && DazProductSlab.presets[presetKey]) {
        return presetKey;
    }

    const slabTemplate = $container.attr('data-slab');
    if (slabTemplate && DazProductSlab.legacyTemplatePresets[slabTemplate]) {
        return DazProductSlab.legacyTemplatePresets[slabTemplate];
    }

    const holderTemplate = $container.attr('data-slabholder');
    if (holderTemplate && DazProductSlab.legacyHolderPresets[holderTemplate]) {
        return DazProductSlab.legacyHolderPresets[holderTemplate];
    }

    return 'default';
};

DazProductSlab.parseSlabOptions = function ($container) {
    const presetKey = DazProductSlab.resolvePresetKey($container);
    const options = DazProductSlab.cloneOptions(presetKey);

    const layoutOverride = $container.attr('data-slab-layout');
    if (layoutOverride) {
        options.layout = layoutOverride;
    }

    for (let i = 0; i < DazProductSlab.optionAttrMap.length; i++) {
        const attr = DazProductSlab.optionAttrMap[i][0];
        const key = DazProductSlab.optionAttrMap[i][1];
        const value = DazProductSlab.readBoolAttr($container, attr);
        if (value !== undefined) {
            options[key] = value;
        }
    }

    if ($container.attr('data-exclude-wishlist') === 'true') {
        options.showWishlist = false;
    }
    if ($container.attr('data-exclude-prices') === 'true') {
        options.showSalePrice = false;
        options.showBasePrice = false;
        options.showAmountSaved = false;
    }
    if ($container.attr('data-exclude-icons') === 'true') {
        options.showCategoryIcons = false;
        options.showDazPlus = false;
        options.showDazOriginal = false;
    }

    return options;
};

DazProductSlab.applySlabDomState = function (root, data) {
    const flag = function (v) {
        return v ? 'true' : 'false';
    };
    root.setAttribute('data-is-new', flag(data.isNew));
    root.setAttribute('data-on-sale', flag(data.onSale));
    root.setAttribute('data-is-outlet', flag(data.isOutlet));
    root.setAttribute('data-owned', flag(data.owned));
    root.setAttribute('data-in-cart', flag(data.inCart));
    root.setAttribute('data-in-wishlist', flag(data.inWishlist));
    root.setAttribute('data-can-order', flag(data.canOrder));
    root.setAttribute('data-display-price', flag(data.displayPrice !== false));
    root.setAttribute('data-plat-club', flag(data.platClub));
    root.setAttribute('data-daz-original', flag(data.dazOriginal));
    root.setAttribute('data-prod-isnew', flag(data.isNew));
    root.setAttribute('data-prod-isonsale', flag(data.onSale));
};

DazProductSlab.prepareRenderData = function (data, options) {
    const o = options || DazProductSlab.presets.default;
    const isOutlet = !!data.isOutlet;
    const percentOff = data.percentDiscount > 0;

    data.renderMinicartData = !!o.showMinicartData;
    data.renderWishlist = !!o.showWishlist;
    data.renderWishlistBadge = !!o.showWishlist;
    data.renderOutletFlag = !!o.showOutletFlag && isOutlet;
    data.renderNewFlag = !!o.showNewFlag && !!data.isNew && !isOutlet;
    data.renderSaleFlag = !!o.showSaleFlag && !!data.onSale && percentOff && !isOutlet;
    data.renderOwnedBanner = !!o.showOwnedBanner;
    data.renderInCartBanner = !!o.showInCartBanner;
    data.renderSalePrice = !!o.showSalePrice && !!data.onSale;
    data.renderBasePrice = !!o.showBasePrice && !!data.onSale;
    data.renderPriceRegular = !!o.showBasePrice && !data.onSale;
    data.renderAmountSaved = !!o.showAmountSaved && !!data.onSale;
    data.renderPrices = !!(data.renderSalePrice || data.renderBasePrice || data.renderPriceRegular || data.renderAmountSaved);
    data.renderFileFormats = !!o.showFileFormats;
    data.renderCartButtons = !!o.showCartButtons;
    data.renderRemove = !!o.showRemove;
    data.renderDownload = !!o.showDownload;
    data.renderDazPlus = !!o.showDazPlus;
    data.renderDazOriginal = !!o.showDazOriginal;
    data.renderDazBrandIcons = !!(o.showDazPlus || o.showDazOriginal);
    data.renderCategoryIcons = !!o.showCategoryIcons;
    data.renderSpecs = !!(o.showCategoryIcons || o.showDazPlus || o.showDazOriginal);
    data.renderCommerce = !!(
        data.renderFileFormats ||
        data.renderPrices ||
        data.renderCartButtons ||
        data.renderRemove ||
        data.renderDownload
    );

    if (o.preset === 'library' && data.id) {
        data.url = '/downloader/customer/files#prod_' + data.id;
    }

    return data;
};

DazProductSlab.containerShowsWishlist = function ($container) {
    if (!$container.length) {
        return false;
    }
    return DazProductSlab.parseSlabOptions($container).showWishlist;
};

DazProductSlab.init = function (elem) {
    let elemList = elem.find('.daz-slab');

    for (let i = 0; i < elemList.length; i++) {
        let $elem = $(elemList[i]);
        let productIds = [];
        if ($elem.attr('data-categoryid')) {
            productIds = daz.filter.filterProducts(true, {
                'category': [$elem.attr('data-categoryid')],
                'owned': true
            });
            let orderName = $elem.attr('data-order');
            if (!orderName) {
                orderName = 'date';
            }
            let orderDir = $elem.attr('data-order-direction');
            if (!orderDir) {
                orderDir = -1;
            }
            productIds = daz.filter.sortProducts(productIds, orderName, orderDir);
        } else if ($elem.attr('data-products')) {
            productIds = $elem.attr('data-products').split(',');
            for (let ii = 0; ii < productIds.length; ii++) {
                productIds[ii] = productIds[ii].trim();
            }
        }

        if ($elem.attr('data-limit')) {
            productIds = productIds.slice(0, parseInt($elem.attr('data-limit'), 10));
        }

        let hideOwned = true;
        if ($elem.attr('data-showowned') == '1') {
            hideOwned = false;
        }

        if (productIds.length < 1) {
            continue;
        }

        const slabOptions = DazProductSlab.parseSlabOptions($elem);

        // TODO: Unify slabholders
        let holderName = $elem.attr('data-slabholder');
        if (!holderName) {
            holderName = 'slabholder';
        }

        const slabTemplate = Templates.slab;

        $elem.html('');

        for (let ii = 0; ii < productIds.length; ii++) {
            if (hideOwned && daz.filter.productIsOwned(productIds[ii])) {
                continue;
            }
            let slabElemId = "autoslab" + Math.round(Math.random() * 10000000);
            let slabData = {id: productIds[ii], elemId: slabElemId};
            let slabElem = Templates[holderName].render(slabData);
            $elem.append(slabElem);
            let slab = new DazProductSlab(slabData, slabTemplate, '#' + slabElemId, slabOptions);
            slab.load();
        }
    }

    let priceElems = elem.find('.daz-price');

    for (let i = 0; i < priceElems.length; i++) {
        let $priceElem = $(priceElems[i]);
        let pricesJson = $priceElem.attr('data-prices');
        let productId = $priceElem.attr('data-product');
        let stockPrice = $priceElem.attr('data-msrp');
        let freeTrial = $priceElem.attr('data-trial');
        if (pricesJson) {
            let prices = JSON.parse(pricesJson);
            if (prices.hasOwnProperty(daz.cart.currency)) {
                stockPrice = prices[daz.cart.currency].toString();
            }
        }
        let tpl = 'productPrice';
        if ($priceElem.attr('data-template')) {
            let dataTemplate = $priceElem.attr('data-template');
            if (Templates[dataTemplate]) {
                tpl = $priceElem.attr('data-template');
            }
        }
        DazProductSlab.getPrice(productId, stockPrice, pricesJson, freeTrial==='true').then(priceData => {
            $priceElem.html(Templates[tpl].render(priceData)).show();
            if (!priceData.canOrder) {
                elem.find('.btn-cart').hide();
            }
        })
    }
};

DazProductSlab.getPrice = async function (productId, stockPrice, pricesJson, freeTrial = false) {
    let currency
    if (pricesJson) {
        let prices = JSON.parse(pricesJson)
        if (prices.hasOwnProperty(daz.cart.currency)) {
            // Only seems to be used when we are picking a different currency than the default like DAZ points
            currency = daz.cart.currency
        }
        stockPrice = prices[currency].toString()
    }
    let priceData = {}
    if (daz.filter.productIsPlatClubExclusive(productId) && !daz.filter.isPlatClub()) {
        priceData.onSale = false
        priceData.salePrice = ""
        priceData.displayPrice = true
        priceData.basePriceDisplay = "Daz+ Exclusive"
        priceData.canOrder = false
    } else {
        return new Promise(resolve => {
            let price = 0
            daz.api.getPrice(productId, this, function (gotPrice) {
                price = gotPrice
                priceData = DazProductSlab.formatPrice({
                    price: price,
                    basePrice: parseFloat(stockPrice),
                    currency: currency,
                    canOrder: true,
                    freeTrial: freeTrial,
                })

                if (
                    priceData.onSale
                    && priceData.percentDiscount 
                    && priceData.percentDiscount > 0
                ) {
                    const productImgBox = document.querySelector('.product-img-box')

                    if (productImgBox) {
                        const percentOffFlag = productImgBox.querySelector('.percent-off-flag')
                        
                        if (
                            percentOffFlag
                            && percentOffFlag.offsetParent === null // only do stuff if flag not yet shown
                        ) {
                            percentOffFlag.prepend(`${priceData.percentDiscount}% OFF`);
                            percentOffFlag.style.display = 'block';
                        }
                    }
                }

                resolve(priceData);
            })
        })
    }
    return priceData
}

DazProductSlab.formatPrice = function (data) {
    let currency = data.currency;
    if (!currency) {
        currency = daz.cart.currency;
    }
    let basePrice = parseFloat(data.basePrice)

    data.basePriceDisplay = data.basePrice;
    if (currency === "USD") {
        data.salePriceDisplay = basePrice.toFixed(2)
        if (typeof data.price == 'undefined' || data.price == null) {
            data.price = data.basePrice * 100;
        }
        data.salePrice = 0.0;
        data.salePrice = data.price / 100;
        if (data.salePrice < 0.01) {
            data.salePriceDisplay = 'Free';
        } else {
            data.salePriceDisplay = "$" + data.salePrice.toFixed(2)
            data.amountSavedDisplay = "$" + ((basePrice * 100 - data.price) / 100).toFixed(2)
        }

        if (data.salePrice >= basePrice) {
            data.onSale = false;
            if (data.salePrice > basePrice) {
                basePrice = data.salePrice
            }
        } else {
            data.onSale = true;
            data.percentDiscount = Math.round((basePrice - data.salePrice) / basePrice * 100);
        }

        data.basePriceDisplay = basePrice.toFixed(2)
        if (basePrice < 0.01) {
            data.basePriceDisplay = 'Free';
        } else {
            data.basePriceDisplay = '$' + data.basePriceDisplay;
        }
    } else if (currency === "DAZ") {
        data.basePriceDisplay = "¤" + data.basePriceDisplay;
    } else {
        if (basePrice < 0.01) {
            data.basePriceDisplay = 'Free';
        } else {
            data.basePriceDisplay = data.basePrice;
        }
    }

    if (data.price < 0.01 && data.basePrice > 0 && data.freeTrial) {
        data.onSale = false;
        data.basePriceDisplay = "Free Trial"
    } else {
        data.freeTrial = false;
    }
    data.canOrder = data.canOrder && currency === daz.cart.currency;
    if (data.isDisabled) {
        data.onSale = false;
        data.basePriceDisplay = "Inactive";
        data.canOrder = false;
    }
    return data;
};

window.loadedSlabs = {};
DazProductSlab.prototype.load = function () {
    const slabCacheKey = this.productData.id + ':' + DazProductSlab.slabApiCacheVersion;
    const slabUrl = '/dazApi/slab/' + this.productData.id + '?slab=' + DazProductSlab.slabApiCacheVersion;
    if (window.loadedSlabs[slabCacheKey]) {
        window.loadedSlabs[slabCacheKey].then(data => {
            this.loadAjax(data);
            return data;
        })
        return;
    }
    DazProductSlab.requestCount++;
    window.loadedSlabs[slabCacheKey] = fetch(slabUrl)
        .then(response => {
            return response.json();
        }).then(data => {
            this.loadAjax(data);
            return data;
        }).catch(error => {
            // flip the flag to false so we don't try to load the slab again
            this.needSlab = false;
            DazProductSlab.requestCount--;
            // Lets send this to Sentry
            Sentry.captureMessage("Slab failed to load " + this.productData.id ? this.productData.id : "but I don't have an ID :/", "error");
            console.log(error);
        });
};

DazProductSlab.prototype.loadFilter = function () {
    this.productData.owned = daz.filter.productIsOwned(this.productData.id);
    this.productData.inCart = daz.filter.productIsInCart(this.productData.id);
    this.productData.inWishlist = daz.filter.productIsInWishlist(this.productData.id);

    if (!this.productData.inCart && !this.productData.owned) {
        this.productData.canOrder = true;
    } else {
        this.productData.canOrder = false;
    }

    this.needFilter = false;
    this.partLoaded();
};

DazProductSlab.prototype.loadPrice = function (price) {
    this.productData.price = price;

    this.needPrice = false;
    this.partLoaded();
};

DazProductSlab.prototype.loadAjax = function (ajaxData) {
    DazProductSlab.requestCount--;
    if (ajaxData === null || ajaxData === undefined || Object.keys(ajaxData).length < 1) {
        this.drawFailure();
        return;
    }
    for (let idx in ajaxData) {
        if (idx === 'price') {
            this.productData.basePrice = parseFloat(ajaxData.price);
        } else if (idx === 'trial') {
            this.productData.trial = ajaxData.trial
        } else if (idx === 'mature') {
            this.productData.mature = !!ajaxData.mature;
        } else if (idx === 'outlet') {
            this.productData.isOutlet = !!ajaxData.outlet;
        } else if (idx === 'currency') {
            this.productData.currency = ajaxData.currency
        } else if (idx === 'prices') {
            let hasPrice = false;
            for (let cur in ajaxData.prices) {
                if (cur === daz.cart.currency && ajaxData.prices.hasOwnProperty(cur)) {
                    // For addons, productData should already have basePrice in pennies.
                    // Use this if possible, since the ajaxData price is a generic price
                    // rather than the addon price set for this specific product.
                    if (ajaxData.type === 'addon' && this.productData.basePrice) {
                        this.productData.basePrice = parseFloat(this.productData.basePrice / ((cur === 'USD') ? 100 : 1));
                    } else {
                        this.productData.basePrice = parseFloat(ajaxData.prices[cur]);
                    }
                    this.productData.currency = cur;
                    this.productData.canOrder = true;
                    hasPrice = true;
                    break;
                }
            }
            if (!hasPrice) {
                this.productData.basePrice = 0;
                this.productData.currency = daz.cart.currency;
                this.productData.canOrder = false;
            }
        } else {
            this.productData[idx] = ajaxData[idx];
        }
    }
    this.productData.platClubExclusive = daz.filter.productIsPlatClubExclusive(ajaxData.id);
    if (this.productData.platClubExclusive && !daz.filter.isPlatClub()) {
        this.productData.onSale = false;
        this.productData.salePrice = "";
        this.productData.displayPrice = true;
        this.productData.basePriceDisplay = "Daz+ Exclusive";
        this.productData.canOrder = false;
    }
    if (this.productData.trial) {
        this.productData.onSale = false;
        this.productData.basePriceDisplay = 'Free Trial';
        this.productData.freeTrialDisplay = 'Free Trial';
    }
    if (this.productData.type === 'giftcard') {
        this.productData.canOrder = false;
    }
    // Lets face it... this is probably never used
    if (this.productData.type === 'opensea' && daz.opensea) {
        daz.opensea.LoadSlab(this, 5);
    } else {
        this.needSlab = false;
    }
    if ($(this.elemSelector).attr('data-nameoverride')) {
        this.productData.name = $(this.elemSelector).attr('data-nameoverride');
    }
    this.partLoaded();
};

DazProductSlab.prototype.partLoaded = function () {
    if (!this.needFilter && !this.needPrice && !this.needSlab) {
        this.draw();
    }
};

DazProductSlab.prototype.draw = function () {
    const elem = $(this.elemSelector)[0];
    if (!elem) {
        return;
    }
    daz.mature.is(false).then((showMature) => {
        let data = this.productData;


        data.displayPrice = true;
        if (data.type == 'giftcard') {
            data.displayPrice = false;
        } else if (data.type === 'opensea') {
            data.onSale = false;
            data.salePrice = "";
            data.displayPrice = data.canOrder;
            if (data.quantity <= 1) {
                delete data["quantity"];
            }
        } else if (data.platClubExclusive && !daz.filter.isPlatClub()) {
            // do nothing, we just don't want the price to be formatted
        } else {
            data = DazProductSlab.formatPrice(data);
        }

        if (Date.now() / 1000 < data.newTime) {
            data.isNew = true;
        } else {
            data.isNew = false;
        }

        const $optionsScope = $(this.elemSelector).closest('.daz-slab, [data-slab-preset]');
        const slabOptions = $optionsScope.length
            ? DazProductSlab.parseSlabOptions($optionsScope)
            : this.slabOptions;
        data = DazProductSlab.prepareRenderData(data, slabOptions);

        if (!elem) {
            if (this.retryCount > 0) {
                this.retryCount--;
                window.setTimeout($.proxy(function () {
                    this.draw();
                }, this), 50);
            }
            return;
        }

        elem.setAttribute('data-placeholder', '0');
        elem.innerHTML = this.templateFunc.render(data);

        const slabRoot = elem.querySelector('.slab-card');
        if (slabRoot) {
            DazProductSlab.applySlabDomState(slabRoot, data);
        }

        const $container = $(this.elemSelector).closest('.daz-slab, [data-slab-preset]');
        if (DazProductSlab.containerShowsWishlist($container)) {
            const wishlistContainer = elem.querySelector('.wishlist-buttons');
            if (wishlistContainer) {
                DazWishlist.register(wishlistContainer);
            }
        }

        if (data.mature && !showMature) {
            daz.mature.push(new DazMatureSlab(elem, data));
        }
    });
};

DazProductSlab.prototype.getProductPrice = function (price) {
    return price;
}

DazProductSlab.prototype.drawFailure = function () {
    const elem = $(this.elemSelector)[0];
    if (!elem) {
        return;
    }
    
    Sentry.captureMessage("Slab failed to load " + this.productData.id ? this.productData.id : "but I don't have an ID :/", "error");

    elem.innerHTML = Templates.slabFailure.render({});
    elem.setAttribute('data-placeholder', '0');
    elem.setAttribute('data-failure', '1');
}

$(function () {
    daz.filter.onLoad(DazProductSlab, function () {
        DazProductSlab.init($(document));
    });
});
let mmm = 0;
